import { useSelector } from 'react-redux';

import { selectIsWellnessLoading, selectWellnessData } from '@lib/core/productAttributes/selectors';

export const useWellness = () => ({
  isWellnessLoading: useSelector(selectIsWellnessLoading),
  wellnessData: useSelector(selectWellnessData),
});
